import { render, staticRenderFns } from "./VerificationResults.vue?vue&type=template&id=b2b5c0ea&scoped=true"
import script from "./VerificationResults.vue?vue&type=script&lang=ts"
export * from "./VerificationResults.vue?vue&type=script&lang=ts"
import style0 from "./VerificationResults.vue?vue&type=style&index=0&id=b2b5c0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b5c0ea",
  null
  
)

export default component.exports